import React, { memo, useCallback } from "react";
import { DatoKeyValuesMap } from "../data/datoContentData";
import { Wrapper, Container } from "../styles/components/section";
import Component from "./component";

const Section = memo(({ datoContentData, isLoaded }) => {
  const findComponentByKey = useCallback(key => {
    const section = DatoKeyValuesMap.find(section => section.key === key);
    if (!section) {
      return null;
    }
    return section.component;
  }, []);

  const articleData = datoContentData?.find(
    item => item.key === "article--data"
  );

  return (
    <Wrapper>
      {datoContentData?.map((contentItem, index) => {
        const SectionComponent = contentItem.key
          ? findComponentByKey(contentItem.key)
          : contentItem;

        if (!SectionComponent) return null;

        return (
          <Container
            key={contentItem.id || contentItem.key || index}
            className={contentItem.key || contentItem.id}
          >
            {contentItem.key ? (
              <SectionComponent
                articleData={articleData}
                {...(contentItem.key === "component--landing"
                  ? { isLoaded }
                  : {})}
                {...contentItem.content}
              />
            ) : (
              <Component {...contentItem} />
            )}
          </Container>
        );
      })}
    </Wrapper>
  );
});

export default memo(Section);
